export const SPECIES_MAP_SINGLE_PIN_ZOOM = 8.5;
